import { Grid } from "@material-ui/core";
import React, { useCallback, useEffect, useState } from 'react'
import { Container, Typography, Box, Card, CardContent, Avatar, ToggleButton, ToggleButtonGroup, CircularProgress, FormControl, Select, MenuItem, SelectChangeEvent, RadioGroup, FormControlLabel, Radio, Divider } from "@mui/material";
import { UrlConstant } from "../../../commom/UrlConstant";
import Axios from "../../../config/axios";
import useCryptoLoan from "../../../commom/hooks/useCryptoLoan";
import DonutChart from "../charts/DonutChart";
import { getUserFromLocalStorage } from "../../../utils/utils";
import PortfolioTabel from "../Tabels/PortfolioTabel";
import Footer from "../Layout/Footer";
import LinechartMiniPortfolio from "../charts/LinechartMiniPortfolio";
import { usePriceFormatter } from "../../../hooks";
import { formatPercentage } from "../../../utils/formatting";
import { useAppSelector } from "../../../Redux/hooks";

function Portfolio() {

  const user = getUserFromLocalStorage();

  // Initialize formatter
  const formatter = usePriceFormatter();

  // Get currency info from Redux
  const currencyInfo = useAppSelector((state) => state.currency);

  const CRYPTO_CHART_LIMIT = 5; // Show top 4 coins + "Other" if there are more

  const [loading, setLoading] = useState<any>(false);
  const [tradingInfo, setTradingInfo] = useState<any>();
  const [investmentChart, setInvestmentChart] = useState<any>()
  const [stockChart, setStockChart] = useState<any>()
  const [stockChartLabel, setStockLabel] = useState<any>()
  const [portfolioData, setPortfolioData] = useState<any>()
  const [portfolioListData, setPortfolioListData] = useState<any>()
  const [stockChartType, setStockChartType] = React.useState<any>('stockChart');
  const [portfolioView, setPortfolioView] = useState<'Total' | 'Net'>('Total');

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [selectedType, setSelectedType] = useState("Crypto");

  // investmentChart
  const [investmentData, setInvestmentData] = useState<any>()
  const [investmentFilter, setInvestmentFilter] = useState<any>("1W")
  const [changeInvestmentData, setChangeInvestmentData] = useState<any>()
  const [changePercentageInvestmentData, setChangePercentageInvestmentData] = useState<any>()
  const [accountValue, setAccountValue] = useState<any>()
  const tabOptions = [{ label: "1W", value: "1W" }, { label: "1M", value: "1M" }, { label: "3M", value: "3M" }, { label: "6M", value: "6M" }, { label: "1Y", value: "1Y" }, { label: "5Y", value: "5Y" }]
  const [investmentType, setInvestmentType] = useState<'crypto' | 'stock'>('crypto');

  const handleRadioChange = (event) => {
    setSelectedType(event.target.value);
  };

  const handleChange = (event: SelectChangeEvent) => {
    setStockChartType(event.target.value as string);
  };

  const convertToPercentage = (data: number[]) => {
    const total = data.reduce((acc, value) => acc + value, 0);
    if (total === 0) return data.map(() => 0); // Handle edge case when total is 0.

    const rawPercentages = data.map((value) => (value / total) * 100);

    const adjustedPercentages = rawPercentages.map((percentage) => (percentage > 0 && percentage < 1 ? 1 : Math.trunc(percentage)));

    return adjustedPercentages;
  };

  const handlePortfolioViewChange = (event: SelectChangeEvent) => {
    setPortfolioView(event.target.value as 'Total' | 'Net');
  };

  useEffect(() => {
    const totalCash = tradingInfo?.Balances?.CashBalance || 0;

    const stockValue = portfolioData?.stockChart?.stockTotal || 0;
    const etfValue = portfolioData?.mainChart?.chartData?.ETF || 0;
    const cryptoValue = portfolioData?.cryptoChart?.cryptoTotal || 0;

    // Get total crypto loan amount
    const cryptoLoanAmount = portfolioData?.cryptoLoanSummary?.remainingLoanAmount || 0;

    if (portfolioView === 'Total') {
      // Total view: Show everything as-is
      const data = [totalCash, stockValue, etfValue, cryptoValue];
      const labels = ["Cash", "Stocks", "ETFs", "Crypto"];

      const finalDataPer = data?.length && convertToPercentage(data);
      const finalData = labels?.map((item, i) => {
        return {
          label: item,
          value: data[i],
          percentage: finalDataPer[i]
        };
      });

      setInvestmentChart(finalData);
    } else {
      // Net view: Subtract crypto loan from crypto value and crypto cash
      const netCryptoValue = Math.max(0, cryptoValue - cryptoLoanAmount);
      // console.log(cryptoCash, "cryptoCash");
      // console.log(cryptoLoanAmount, 'cryptoLoanAmount');
      // console.log(cryptoValue, 'cryptoValue');




      // const netCryptoCash = Math.max(0, cryptoCash - Math.max(0, cryptoLoanAmount - cryptoValue));
      // console.log(netCryptoCash, 'netCryptoCash');
      // const netTotalCash = tradingCash + netCryptoCash;
      // console.log(tradingCash, 'tradingCash');
      // console.log(netTotalCash, 'netTotalCash');

      const data = [totalCash, stockValue, etfValue, netCryptoValue];
      const labels = ["Cash", "Stocks", "ETFs", "Crypto"];

      const finalDataPer = data?.length && convertToPercentage(data);
      const finalData = labels?.map((item, i) => {
        return {
          label: item,
          value: data[i],
          percentage: finalDataPer[i]
        };
      });

      setInvestmentChart(finalData);
    }
  }, [tradingInfo, portfolioData, portfolioView]);

  const fetchTradingBalance = async () => {
    setLoading(true);

    let tradingCash = 0;
    let cryptoCash = 0;

    try {
      const accountId = user?.tradingblock_application_id;

      try {
        const tradingRes = await Axios.post(
          UrlConstant.BuySell.GetTradingBalance,
          { accountId }
        );
        tradingCash =
          Number(tradingRes?.data?.data?.Payload?.Balances?.CashBalance) || 0;
      } catch (err) {
        console.warn('Trading balance API failed', err);
      }

      try {
        const currency = currencyInfo.code?.toLowerCase() || 'usd';
        const cryptoRes = await Axios.get(UrlConstant.User.GetUserBalance, {
          params: { type: 'fiat', currency }
        });
        const fiatObj = Array.isArray(cryptoRes.data.data.balances)
          ? cryptoRes.data.data.balances.find(item => item.currency === currency)
          : null;
        cryptoCash = Number(fiatObj?.available) || 0;
      } catch (err) {
        console.warn('Crypto balance API failed', err);
      }

      const totalCash = tradingCash + cryptoCash;

      setTradingInfo({
        Balances: { CashBalance: totalCash },
        BuyingPower: { AvailableFunds: totalCash },
        tradingCash,
        cryptoCash,
      });
    } finally {
      setLoading(false);
    }
  }

  const fetchCryptoPortfolio = async () => {
    try {
      const response = await Axios.get(UrlConstant.User.Portfolio)
      return response?.data?.data?.portfolio || []
    } catch (error: any) {
      console.error("Crypto portfolio error : ", error)
      return []
    }
  }

  const { refetch: fetchCryptoLoan } = useCryptoLoan({ autoFetch: false });

  const loadPortfoliosForTable = async () => {
    setLoading(true);

    try {
      const [stockRes, cryptoRes, cryptoLoanRes] = await Promise.allSettled([
        (async () => {
          const data = { accountId: user?.tradingblock_application_id };
          const res = await Axios.post(UrlConstant.Portfolio.GetPortfolio, data);
          return res?.data?.data || {};
        })(),
        fetchCryptoPortfolio(),
        fetchCryptoLoan()
      ]);

      const stockData = stockRes.status === "fulfilled" && stockRes.value ? stockRes.value : {};
      const cryptoRaw = cryptoRes.status === "fulfilled" && cryptoRes.value ? cryptoRes.value : null;
      const cryptoLoanData = cryptoLoanRes.status === "fulfilled" && cryptoLoanRes.value
        ? cryptoLoanRes.value
        : { stockData: [], totalLoanAmount: 0, closedLoanAmount: 0, remainingLoanAmount: 0 };

      // const cryptoList = cryptoRaw
      //   ? Array.isArray(cryptoRaw.data)
      //     ? cryptoRaw
      //     : Array.isArray(cryptoRaw)
      //       ? { data: cryptoRaw, summary: { totalValue: 0 } }
      //       : { data: [], summary: { totalValue: 0 } }
      //   : { data: [], summary: { totalValue: 0 } };

      // const totalCryptoValue = cryptoList.summary?.totalValue || 0;

      const cryptoList = cryptoRaw || [];
      const cryptoSummary = {};

      const totalCryptoValue = cryptoList.reduce(
        (sum, item) => sum + (item.currentValue || 0),
        0
      );
      // Merge portfolio data for dashboard
      const portfolioDataWithCrypto = {
        ...stockData,
        cryptoList: cryptoList,
        cryptoChart: {
          cryptoTotal: totalCryptoValue,
          chartDataTest: Array.isArray(cryptoList)
            ? cryptoList.map(crypto => ({
              symbol: crypto.code,
              amount: crypto.totalValue,
              percentage: crypto.percentage
            }))
            : []
        },
        cryptoLoanSummary: {
          remainingLoanAmount: cryptoLoanData.remainingLoanAmount,
          closedLoanAmount: cryptoLoanData.closedLoanAmount,
          totalLoanAmount: cryptoLoanData.totalLoanAmount
        }
      };

      setPortfolioData(portfolioDataWithCrypto);

      const stockEntries = Array.isArray(stockData?.entries)
        ? stockData.entries.map(item => ({ ...item }))
        : [];

      const cryptoEntries = Array.isArray(cryptoList)
        ? cryptoList.map(c => {
          const matchedLoan = cryptoLoanData?.stockData?.find(
            s => s.stockSymbol?.toLowerCase() === c.code?.toLowerCase()
          );

          return {
            symbol: c.code,
            currencyPair: c.currencyPair,
            quantity: c.quantity,
            value: c.currentValue,
            gainPercent: c.pnlRatio,       // total return %
            gainValue: c.pnl,              // total return value
            todayReturnPercent: c.todayReturnPercent,
            todayReturnValue: c.todayReturnValue,
            cmcId: c.cmcId,
            costValue: c.investedValue,
            percentage: c.percentage,
            quote: {
              branding: { icon_url: c.logo, logo_url: c.logo },
              price: c.usdQuote?.price || 0,
              companyName: c.company || c.assetName,
              lastPrice: c.avgPrice,
              value: c.currentValue
            },
            loanAmount: matchedLoan?.loanAmount ?? 0,
            stockId: matchedLoan?.stockId ?? null,
            type: "Crypto"
          };
        })
        : [];

      setPortfolioListData([...cryptoEntries, ...stockEntries]);
    } catch (error) {
      // console.error("Unexpected error loading portfolios", error);
      setPortfolioListData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchCryptoInvestmentChart = useCallback(async () => {
    setLoading(true);
    try {
      const res = await Axios.get(
        UrlConstant.Crypto.GetCryptoInvestmentChart +
        `?filter=${investmentFilter}`
      );

      if (
        res?.data?.status &&
        res.data.data?.responseData?.length > 0
      ) {
        const {
          responseData,
          change,
          changePercentage,
          accountValue,
        } = res.data.data;

        // Chart data
        const chartData = responseData.map((item: any) => ({
          x: new Date(item.x),
          y: item.y,
        }));

        // State updates
        setInvestmentData(chartData);
        setChangeInvestmentData(change);
        setChangePercentageInvestmentData(changePercentage);
        setAccountValue(accountValue);
      } else {
        // Empty state
        setInvestmentData([]);
        setChangeInvestmentData(0);
        setChangePercentageInvestmentData("0.00");
        setAccountValue(0);
      }
    } catch (error) {
      console.error("Error fetching crypto investment chart:", error);
      setInvestmentData([]);
      setChangeInvestmentData(0);
      setChangePercentageInvestmentData("0.00");
      setAccountValue(0);
    } finally {
      setLoading(false);
    }
  }, [investmentFilter]);

  const fetchStockInvestmentChart = useCallback(async () => {
    setLoading(true);
    try {
      const res = await Axios.get(
        UrlConstant.InvestmentChart.getInvestmentChart.replace("{0}", investmentFilter)
      );

      if (res?.data?.status && res.data.data?.responseData?.length > 0) {
        const { responseData, change, changePercentage, accountValue } = res.data.data;

        const chartData = responseData.map((item: any) => ({
          x: new Date(item.recordDate),
          y: item.accountValue,
        }));

        setInvestmentData(chartData);
        setChangeInvestmentData(change);
        setChangePercentageInvestmentData(changePercentage);
        setAccountValue(accountValue);
      } else {
        setInvestmentData([]);
        setChangeInvestmentData(0);
        setChangePercentageInvestmentData("0.00");
        setAccountValue(0);
      }
    } catch (error) {
      console.error("Error fetching stock investment chart:", error);
      setInvestmentData([]);
      setChangeInvestmentData(0);
      setChangePercentageInvestmentData("0.00");
      setAccountValue(0);
    } finally {
      setLoading(false);
    }
  }, [investmentFilter]);

  // const fetchInvestmentChart = useCallback(async () => {
  //   setLoading(true);
  //   try {
  //     const [stockRes, cryptoRes] = await Promise.allSettled([
  //       Axios.get(
  //         UrlConstant.InvestmentChart.getInvestmentChart.replace("{0}", investmentFilter)
  //       ),
  //       Axios.get(
  //         UrlConstant.Crypto.GetCryptoInvestmentChart +
  //         `?filter=${investmentFilter}`
  //       ),
  //     ]);

  //     // Handle stock data with fallback
  //     let stockData: { date: string; stock: number }[] = [];
  //     let stockHasData = false;
  //     if (
  //       stockRes.status === "fulfilled" &&
  //       stockRes.value?.data?.status &&
  //       Array.isArray(stockRes.value.data.data.responseData) &&
  //       stockRes.value.data.data.responseData.length > 0
  //     ) {
  //       stockData = stockRes.value.data.data.responseData.map((item: any) => ({
  //         date: item.recordDate.split("T")[0],
  //         stock: item.accountValue,
  //       }));
  //       stockHasData = true;
  //     } else {
  //       console.warn("Stock data unavailable or empty:", stockRes.status === "fulfilled" ? "No data" : stockRes.reason);
  //     }

  //     // Handle crypto data with fallback
  //     let cryptoData: { date: string; crypto: number }[] = [];
  //     let cryptoHasData = false;
  //     if (
  //       cryptoRes.status === "fulfilled" &&
  //       cryptoRes.value?.data?.status &&
  //       Array.isArray(cryptoRes.value.data.data.responseData) &&
  //       cryptoRes.value.data.data.responseData.length > 0
  //     ) {
  //       cryptoData = cryptoRes.value.data.data.responseData.map((item: any) => ({
  //         date: item.x.split("T")[0],
  //         crypto: item.y,
  //       }));
  //       cryptoHasData = true;
  //     } else {
  //       console.warn("Crypto data unavailable or empty:", cryptoRes.status === "fulfilled" ? "No data" : cryptoRes.reason);
  //     }

  //     // If both APIs failed or have no data, show empty state
  //     if (!stockHasData && !cryptoHasData) {
  //       console.warn("Both stock and crypto data are unavailable");
  //       setInvestmentData([]);
  //       setChangeInvestmentData(0);
  //       setChangePercentageInvestmentData("0.00");
  //       setAccountValue(0);
  //       return;
  //     }

  //     // Get all unique dates and sort them
  //     const allDates = Array.from(
  //       new Set([
  //         ...stockData.map(d => d.date),
  //         ...cryptoData.map(d => d.date)
  //       ])
  //     ).sort();

  //     // Create maps for quick lookup
  //     const stockMap = new Map(stockData.map(d => [d.date, d.stock]));
  //     const cryptoMap = new Map(cryptoData.map(d => [d.date, d.crypto]));

  //     // Initialize with first available values
  //     let lastStockValue = 0;
  //     let lastCryptoValue = 0;

  //     if (stockHasData && stockData.length > 0) {
  //       lastStockValue = stockData[0].stock;
  //     }
  //     if (cryptoHasData && cryptoData.length > 0) {
  //       lastCryptoValue = cryptoData[0].crypto;
  //     }

  //     // Build merged data with carry-forward logic
  //     const merged: { x: Date; stock: number; crypto: number; total: number }[] = [];

  //     allDates.forEach((date) => {
  //       const currentStockValue = stockMap.get(date);
  //       const currentCryptoValue = cryptoMap.get(date);

  //       // Stock update logic: skip zeros (market closed)
  //       if (stockHasData && currentStockValue !== undefined && currentStockValue !== 0) {
  //         lastStockValue = currentStockValue;
  //       }

  //       // Crypto update logic: accept all values including 0
  //       if (cryptoHasData && currentCryptoValue !== undefined) {
  //         lastCryptoValue = currentCryptoValue;
  //       }

  //       merged.push({
  //         x: new Date(date + "T00:00:00.000Z"),
  //         stock: lastStockValue,
  //         crypto: lastCryptoValue,
  //         total: lastStockValue + lastCryptoValue,
  //       });
  //     });

  //     // Find FIRST NON-ZERO value for accurate percentage calculation
  //     const firstNonZeroValue = merged.find(d => d.total > 0)?.total || 0;
  //     const lastValue = merged[merged.length - 1]?.total || 0;
  //     const change = lastValue - firstNonZeroValue;

  //     const changePercentage = firstNonZeroValue !== 0
  //       ? ((change / firstNonZeroValue) * 100).toFixed(2)
  //       : "0.00";

  //     // Update state
  //     setInvestmentData(merged.map(d => ({ x: d.x, y: d.total })));
  //     setChangeInvestmentData(change);
  //     setChangePercentageInvestmentData(changePercentage);
  //     setAccountValue(lastValue);

  //   } catch (error) {
  //     console.error("Unexpected error in fetchInvestmentChart:", error);
  //     setInvestmentData([]);
  //     setChangeInvestmentData(0);
  //     setChangePercentageInvestmentData("0.00");
  //     setAccountValue(0);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [investmentFilter]);

  useEffect(() => {
    if (currencyInfo.loading) return;
    fetchTradingBalance();
    loadPortfoliosForTable();
  }, [currencyInfo.loading]);

  useEffect(() => {
    if (investmentType === 'crypto') {
      fetchCryptoInvestmentChart();
    } else {
      fetchStockInvestmentChart();
    }
  }, [investmentType, investmentFilter, fetchCryptoInvestmentChart, fetchStockInvestmentChart])

  // useEffect(() => {
  //   const cash = tradingInfo?.Balances?.CashBalance || 0
  //   const stock = portfolioData?.stockChart?.stockTotal || 0
  //   const ETF = portfolioData?.mainChart?.chartData?.ETF || 0
  //   const crypto = portfolioData?.cryptoChart?.cryptoTotal || 0 // Add crypto total

  //   const data = [cash, stock, ETF, crypto]
  //   const labels = ["Cash", "Stocks", "ETFs", "Crypto"]

  //   const finalDataPer = data?.length && convertToPercentage(data)
  //   const finalData = labels?.map((item, i) => {
  //     return {
  //       label: item,
  //       value: data[i],
  //       percentage: finalDataPer[i]
  //     }
  //   })

  //   console.log(data, finalDataPer, 'finalData')
  //   setInvestmentChart(finalData)
  // }, [tradingInfo, portfolioData])

  useEffect(() => {
    if (selectedType === "Crypto") {
      // Handle crypto chart data
      const cryptoData = portfolioData?.cryptoList || [];
      const finalData = cryptoData.map(item => item.totalValue || item.currentValue);
      const finalDataLabel = cryptoData.map(item => item.code);
      const finalDataPer = cryptoData.map(item => item.percentage || 0);

      let newData = finalDataLabel?.map((item, i) => {
        return {
          label: item,
          value: finalData[i],
          percentage: finalDataPer[i]
        }
      });

      // Apply crypto chart limit logic - show top 4 coins and aggregate rest as "Other"
      let limitedData = newData;
      if (newData && newData.length > CRYPTO_CHART_LIMIT) {
        // Sort by value in descending order
        const sortedData = [...newData].sort((a, b) => b.value - a.value);

        // Take top 4 coins
        const topCoins = sortedData.slice(0, CRYPTO_CHART_LIMIT - 1);

        // Aggregate remaining coins into "Other"
        const otherCoins = sortedData.slice(CRYPTO_CHART_LIMIT - 1);
        const otherValue = otherCoins.reduce((sum, coin) => sum + coin.value, 0);
        const otherPercentage = otherCoins.reduce((sum, coin) => sum + coin.percentage, 0);

        limitedData = [...topCoins];
        if (otherValue > 0) {
          limitedData.push({ label: 'Other', value: otherValue, percentage: otherPercentage });
        }
      }

      setStockChart(limitedData);
      setStockLabel(limitedData?.map(item => item.label));
    } else {
      // Handle stock/ETF chart data
      let data = portfolioData?.[stockChartType]?.chartDataTest;
      const finalData = data?.map((item) => item.amount);
      const finalDataLabel = data?.map((item) => item.symbol);
      const finalDataPer = finalData?.length && convertToPercentage(finalData);

      const newData = finalDataLabel?.map((item, i) => {
        return {
          label: item,
          value: finalData[i],
          percentage: finalDataPer[i]
        }
      });

      setStockChart(newData);
      setStockLabel(finalDataLabel);
    }
  }, [selectedType, stockChartType, portfolioData])

  useEffect(() => {
    if (selectedType == "ETF") {
      setStockChartType("etfChart")
    } else if (selectedType == "Stock") {
      setStockChartType("stockChart")
    }
  }, [selectedType])

  return <>
    <Container maxWidth={false} className="bg-color" style={{ display: 'flex', flexDirection: 'column', minHeight: 'calc(100vh - 71px - 143px)', height: 'fit-content' }}>
      <Box padding='30px' flexGrow='1'>
        {loading && (
          <Box
            position="fixed"
            top={0}
            left={0}
            width="100vw"
            height="100vh"
            bgcolor="rgba(0, 0, 0, 0.5)" // Semi-transparent black background
            display="flex"
            justifyContent="center"
            alignItems="center"
            style={{
              backdropFilter: "blur(5px)", // Blur effect
              zIndex: 9999, // Ensures the loader stays above all elements
            }}
          >
            <CircularProgress color="primary" />
          </Box>
        )}
        <Typography variant="body1" fontSize='24px' fontWeight={400} className="text-white">Portfolio Details</Typography>
        <Box display="flex" flexDirection={{ xs: "column", md: "row" }} gap="10px" my="20px" alignItems="stretch">
          {/* First Card with Chart */}
          <Box flex={1} display="flex">
            <Card className="card" style={{ width: "100%", height: "100%", padding: "12px 10px" }}>
              <CardContent className="text-white" style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                <Grid container spacing={2}>
                  {/* Title with Dropdown */}
                  <Grid item xs={12}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                      <Typography variant="h6" className="text-white" style={{ textAlign: "left" }}>
                        Investment Portfolio
                      </Typography>
                      <FormControl size="small" sx={{ minWidth: 100 }}>
                        <Select
                          value={portfolioView}
                          onChange={handlePortfolioViewChange}
                          className="text-white"
                          sx={{
                            borderRadius: '9px',
                            height: '36px',
                            '& .MuiSelect-select': {
                              padding: '8px 12px',
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'rgba(255, 255, 255, 0.23)',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'rgba(255, 255, 255, 0.4)',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#F2674A',
                            },
                          }}
                        >
                          <MenuItem value="Total">Total</MenuItem>
                          <MenuItem value="Net">Net</MenuItem>
                        </Select>
                      </FormControl>
                    </Box>
                    {portfolioView === 'Net' && (
                      <Typography
                        variant="caption"
                        className="text-secondary"
                        style={{ fontSize: '12px', marginTop: '4px', display: 'block' }}
                      >
                        Excluding Booster Loans
                      </Typography>
                    )}
                  </Grid>

                  {/* Chart */}
                  <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
                    <DonutChart
                      series={investmentChart?.length ? investmentChart : []}
                      labels={["Cash", "Stocks", "ETFs", "Crypto"]}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Box>

          {/* Second Card with Chart */}
          <Box flex={1} display="flex">
            <Card className="card" style={{ width: "100%", height: "100%", padding: "12px 10px" }}>
              <CardContent className="text-white" style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                <Grid container spacing={2} >
                  {/* Title */}
                  <Grid item xs={12}>
                    <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"} width={"100%"} >
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        width="100%"
                      >
                        <Typography variant="h6" className="text-white">
                          Investment
                        </Typography>

                        <Select
                          value={investmentType}
                          onChange={(e) =>
                            setInvestmentType(e.target.value as "crypto" | "stock")
                          }
                          size="small"
                          sx={{
                            color: 'white',
                            border: '1px solid rgba(255, 255, 255, 0.5)',
                            borderRadius: '8px',
                            '& .MuiSelect-select': {
                              padding: '4px 8px',
                              fontSize: '14px',
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                              border: 'none',
                            },
                          }}
                        >
                          <MenuItem value="crypto">Crypto</MenuItem>
                          <MenuItem value="stock">Stock/ETF</MenuItem>
                        </Select>
                      </Box>
                    </Box>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="flex-start"
                      width="100%"
                      marginTop={1}
                    >
                      {/* LEFT VALUE */}
                      <Typography variant="h6" className="text-white">
                        {formatter.balance(accountValue).display}
                      </Typography>

                      {/* RIGHT CHANGE */}
                      <Box display="flex" flexDirection="column" alignItems="flex-end">
                        {changeInvestmentData > 0 ? (
                          <span style={{ color: "#4edf6d" }}>
                            {formatter.display(changeInvestmentData, { showSign: true })} ({formatPercentage(changePercentageInvestmentData, { showSign: true })})
                          </span>
                        ) : changeInvestmentData === 0 ? (
                          <span style={{ color: "#4edf6d" }}>{changeInvestmentData}</span>
                        ) : (
                          <span style={{ color: "#ff2a2a" }}>
                            {formatter.display(changeInvestmentData, { showSign: true })} ({formatPercentage(changePercentageInvestmentData, { showSign: true })})
                          </span>
                        )}

                        <Typography className="text-secondary" fontSize="14px" fontWeight="bold">
                          Past {investmentFilter}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>

                  {/* Chart */}
                  <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
                    <Box>
                      <LinechartMiniPortfolio height={"275px"} data={investmentData || []} lineColor={
                        changeInvestmentData > 0 ? "#4edf6d" : changeInvestmentData === 0 ? "#4edf6d" : "#ff2a2a"
                      } />
                      <Box display="flex" justifyContent="center" alignItems="center">
                        {tabOptions?.map((item, index) => (
                          //   want to make the tabs like chip and make it dynamic with bg color and text color with active
                          <Box
                            key={index}
                            p={"3px 12px"}
                            m={1} style={{ cursor: 'pointer' }}
                            onClick={() => setInvestmentFilter(item.value)}
                            sx={{
                              backgroundColor: investmentFilter === item.value ? "#F2674A" : 'transparent',
                              color: 'white',
                              border: investmentFilter === item.value ? "" : '1px solid #FFFFFF80',
                              borderRadius: '50px',
                              fontSize: '14px'
                            }}
                          >
                            {item.label}
                          </Box>
                        ))}
                      </Box>

                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Box>

          {/* Third Card with Chart */}
          <Box flex={1} display="flex">
            <Card className="card" style={{ width: "100%", height: "100%", padding: "12px 10px" }}>

              <CardContent className="text-white" style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                <Grid container spacing={2}>
                  {/* Title */}
                  <Grid item xs={12}>
                    <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
                      <RadioGroup
                        row
                        value={selectedType}
                        onChange={handleRadioChange}
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        <FormControlLabel
                          value="Crypto"
                          control={<Radio size="small" sx={{ color: "#3F8EFC" }} />}
                          label={<Typography sx={{ color: "#FFFFFF", fontSize: "14px" }}>Crypto</Typography>}
                        />
                        <FormControlLabel
                          value="Stock"
                          control={<Radio size="small" sx={{ color: "#3F8EFC" }} />}
                          label={<Typography sx={{ color: "#FFFFFF", fontSize: "14px" }}>Stock</Typography>}
                        />
                        <FormControlLabel
                          value="ETF"
                          control={<Radio size="small" sx={{ color: "#3F8EFC" }} />}
                          label={<Typography sx={{ color: "#FFFFFF", fontSize: "14px" }}>ETF</Typography>}
                        />
                      </RadioGroup>

                      {selectedType == "Stock" && (
                        <FormControl >
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={stockChartType}
                            className="text-white"
                            sx={{
                              borderRadius: '9px !important',
                              padding: '0px !important',
                            }}
                            onChange={handleChange}
                          >
                            <MenuItem value={`stockChart`}>Assets</MenuItem>
                            <MenuItem value={`sectorChart`}>Sector</MenuItem>
                          </Select>
                        </FormControl>
                      )}
                      {selectedType === "ETF" && (
                        <FormControl >
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={stockChartType}
                            className="text-white"
                            sx={{
                              borderRadius: '9px !important',
                              padding: '0px !important',
                            }}
                            onChange={handleChange}
                          >
                            <MenuItem value={`etfChart`}>Assets</MenuItem>
                            <MenuItem value={`categoryChart`}>Category</MenuItem>
                          </Select>
                        </FormControl>
                      )}
                    </Box>
                  </Grid>

                  <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
                    <DonutChart
                      series={stockChart?.length ? stockChart : []}
                      labels={stockChartLabel?.length ? stockChartLabel : []}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Box>
        </Box>
        <PortfolioTabel
          portfolioListData={portfolioListData}
        />
      </Box>
    </Container>

  </>;
}

export default Portfolio;
